/**
 * @generated SignedSource<<bdd1bb590fad23376c608a9931f01198>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SpaceStarCurrentSpaceFragment$data = {
  readonly alias: string | null | undefined;
  readonly icon: {
    readonly path: string;
  } | null | undefined;
  readonly id: string | null | undefined;
  readonly key: string | null | undefined;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "SpaceStarCurrentSpaceFragment";
};
export type SpaceStarCurrentSpaceFragment$key = {
  readonly " $data"?: SpaceStarCurrentSpaceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SpaceStarCurrentSpaceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SpaceStarCurrentSpaceFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "alias"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "Icon",
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "path"
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "0e7af2ea53ea33a3d76e321d036b891d";

export default node;
